import _reject from 'lodash/reject';
import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.notification;
const notification = (state = initialSettings, action) => {
  switch (action.type) {
    // ADD
    case types.ADD_NOTIFICATION:
      return {
        ...state,
        list: [...state.list, action.notification],
      };
    // DELETE
    case types.DELETE_NOTIFICATION:
      if (action.id === 0) {
        return {
          ...state,
          list: [],
        };
      }
      return {
        ...state,
        list: _reject(state.list, ['id', action.id]),
      };
    default:
      return state;
  }
};

export default notification;



// WEBPACK FOOTER //
// ./reducers/app/notification.js